import { BaseWorkflowTaskState } from "../../api/clients/workflowTasks/DTOs"

export type OcrWorkflowTaskState = {
	results: OcrResults
	documentBlobId: string
	outputFields: [] // TODO 
	documentName: string
	flagReason?: FlagReason
	documentFormat: DocumentFormat
} & BaseWorkflowTaskState

export type FlagReason = {
	reason: string
	additionalDetails?: string
}

export enum DocumentFormat {
	Portrait = 0,
	Landscape = 1
}

export type OcrResults = {
	formType: string
	formTypeConfidence: number
	pages: OcrPage[]
	fields: OcrField[]
}

export type OcrPage = {
	pageNumber: number
	width: number
	height: number
	unit: string
	words: OcrWord[]
}

export type OcrWord = {
	boundingBox: BoundingBox
	text: string
	confidence: number
}

export type OcrField = OcrValueField | OcrListField

export type OcrValueField = {
	name: string
	value: OcrResultFieldValue
	type: "Value"
}

export type OcrListField = {
	name: string
	value: OcrField[]
	type: "Repeat"
}

export type OcrResultFieldValue = {
	value: unknown
	accepted: boolean
	confidence?: number
	valueType: OcrResultFieldValueType
	boundingBox: BoundingBox
	pageNumber: number
	hintText?: string
	children?: Record<string, OcrResultFieldValue>[]
}

export enum OcrResultFieldValueType {
	String = 0,
	Number = 1,
	Boolean = 2,
	StringArray = 3
}

export type OcrLabelData = {
	boundingBox: BoundingBox
	pageNumber: number
	labelText: string
	hintText?: string
	// children?: Record<string, OcrLabelData>[]
}

export type BoundingBox = {
	x: number
	y: number
}[]

export interface IBoundingBox {
	boundingBox: BoundingBox
}

export function isBoundingBoxEmpty(boundingBox: BoundingBox) {
	for (const coordinate of boundingBox)
		if (coordinate.x !== 0 || coordinate.y !== 0)
			return false
	
	return true

}